import { NextImage } from '@zurich-framework/nextapp/components';
import type { ReactNode } from 'react';
import { Stack } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import type { StepNames } from '~/lib/types';
import { PhotoUploadWithDamageOption } from './PhotoUpload/PhotoUploadWithDamageOption';

export interface StepLayoutProps {
  children: ReactNode;
  illustration?: string;
  alt?: string;
  drawerText?: string;
  cameraButtonText?: string;
  stepName?: StepNames;
  documentDamage?: boolean;
}

export function StepLayout({
  children,
  illustration,
  alt,
  cameraButtonText,
  stepName,
  documentDamage = false,
}: StepLayoutProps) {
  return (
    <StackStyled gap={3} flexDirection="column">
      <Stack gap={3}>
        {illustration && (
          <Stack flexDirection="row" justifyContent="center">
            <NextImage
              width={120}
              height={68}
              src={illustration}
              alt={alt ?? 'Vorschadengutachten-Foto'}
            />
          </Stack>
        )}
        {children}
      </Stack>
      {cameraButtonText && stepName && (
        <Stack paddingTop="16px">
          <PhotoUploadWithDamageOption
            stepName={stepName}
            text={cameraButtonText}
            id={stepName}
            documentDamage={documentDamage}
          />
        </Stack>
      )}
    </StackStyled>
  );
}

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 2),
  [theme.breakpoints.down('lg')]: {
    maxWidth: '800px',
    minHeight: '55vh',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '600px',
    minHeight: '72vh',
  },
  width: '100%',
}));
